import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment/moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { ReactComponent as CloseCircleIcon } from '@assets/icons/close-circle.svg';
import { ReactComponent as SuccessIcon } from '@assets/icons/Success.svg';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import AddDesignToCollection from '@components/design-uploads/AddDesignToCollection';
import ImportedTag from '@components/ImportedTag';
import LoaderComponent from '@components/LoaderComponent';
import MaterialRoadmapView from '@components/MaterialRoadmapView';
import ModalContainer from '@components/modals/ModalContainer';
import OfferPriceDropdown from '@components/offer-price/OfferPriceDropdown';
import TimeBasedLoader from '@components/TimeBasedLoader';
import { toastError, toastInfo, toastSuccess } from '@components/Toast';

import CostingForm from '@features/costing/components/CostingForm';
import DesignSelectionModal from '@features/design/components/DesignSelectionModal';
import DesignUpdate from '@features/design/components/DesignUpdate';
import { getPublishStatus, isAllCriteriaCompleted } from '@features/design/utils/designUtils';
import DesignToolRightSideBar from '@features/designTool/components/DesignToolRightSideBar';
import SelectFolderPopup from '@features/favourites/components/SelectFolderPopup';
import AddedColors from '@features/materials/components/AddedColors';
import BuyerAndNitexMeasurementTable from '@features/measurement/components/BuyerAndNitexMeasurementTable';
import CostingAndPPSampleTable from '@features/measurement/components/CostingAndPPSampleTable';

import { clearCurrentActivePage, setCurrentActivePage } from '@store/actions/ActivePageAction';
import {
	clearDesignTool,
	fetchProductInfo,
	getMemberList,
	productWiseGroupDocument
} from '@store/actions/DesignToolAction';
import { updateDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { processFitWiseSizeList, processMeasurementData } from '@store/actions/MeasurementAction';
import { fetchProductMaterials, likeProduct } from '@store/design/action';
import { getProductMatrials, useDesignViewModal } from '@store/reducers';
import { removeSearchResult, setIsTechpackOpen } from '@store/searchOptions/actions';

import { getDesignPublishStatus } from '@services/collectionService';
import { fetchMaterialUnitType } from '@services/commonService';
import { fetchLatestMeasurementTypeInfo, getPairFabricById } from '@services/measurementService';
import { getPickAndChoosePrice } from '@services/productService';

import {
	categoryTypeSustainabilityForTrimsAndBranding,
	getConsumptionUnit,
	getConsumptionUnitForTrimsAccessories,
	isFabric,
	MATERIAL_TITLE_NAME,
	someDetailsForTrimsAndBrandingRender,
	STATUS
} from '@utils/MaterialsUtil';
import {
	addImageSuffix,
	capitalizeFirstLetter,
	changeDateFormat,
	getFileType,
	insertSeparatorIfNeeded,
	isShowPriceOnDesign,
	printApiError,
	showDesignViewPage
} from '@utils/Util';

import { BASE_FRONT_END_URL, MATERIALS_TYPE } from '@/constants/constant';

import ApiClient from '@/lib/apiClient';

const DesignView = () => {
	const {
		id,
		onCloseViewModal,
		updateProductStatus,
		source,
		orderId,
		designIdList,
		loadMoreDesign,
		onLastDesignReached,
		onUpdateCostingStatus,
		initialCostingId,
		costingItemList,
		isCostingRequestFromBuyer,
		isDefaultOpenBasicInfo,
		isShowCostingPanel,
		isOpenCommentPanel,
		selectedCommentId
	} = useDesignViewModal();
	const designToolCommentStore = useSelector((store) => store.designToolCommentStore);
	const designToolStore = useSelector((store) => store.designToolStore);
	const [isShowUpdateBasicInfo, setIsShowUpdateBasicInfo] = useState(isDefaultOpenBasicInfo);
	const [selectedInitialCostingId, setSelectedInitialCostingId] = useState(null);
	const [hasShowActualAndDiffColumn, setHasShowActualAndDiffColumn] = useState([]);
	const [initialMeasurementTableData, setInitialMeasurementTable] = useState([]);
	const [showAddCollectionPopup, setShowAddCollectionPopup] = useState(false);
	const [productMaterialsTypeObj, setProductMaterialsTypeObj] = useState({});
	const [isShowNitexTechpack, setIsShowNitexTechpack] = useState(false);
	const [sizeCategorySequence, setSizeCategorySequence] = useState({});
	const [openCostingPanel, setOpenCostingPanel] = useState(isShowCostingPanel);
	const [openCommentPanel, setOpenCommentPanel] = useState(isOpenCommentPanel);
	const [initialCostingIds, setInitialCostingIds] = useState([]);
	const [downloadLoading, setDownloadLoading] = useState(false);
	const [measurementTable, setMeasurementTable] = useState([]);
	const [isShowDropdown, setIsShowDropdown] = useState(false);
	const [selectedDocUrl, setSelectedDocUrl] = useState(null);
	const [fitWiseSizeList, setFitWiseSizeList] = useState({});
	const [isNextAndPrev, setIsNextAndPrev] = useState(false);
	const [pomAndSizeList, setPomAndSizeList] = useState([]);
	const [allProductIds, setAllProductIds] = useState([]);
	const [allUnitTypes, setAllUnitTypes] = useState([]);
	const productMaterialsList = useSelector(getProductMatrials);
	const [isShowLook, setIsShowLook] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [productId, setProductId] = useState(null);
	const [basePrice, setBaseprice] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [artBoards, setArtBoards] = useState([]);
	const [activeId, setActiveId] = useState(null);
	const [isLiked, setIsLiked] = useState(false);
	const [otherMeasurementVersion, setOtherMesasurementVersion] = useState([]);
	const [designQrCode, setDesignQrCode] = useState(null);
	const [selectedMaterialRoadmap, setSelectedMaterialRoadmap] = useState(null);
	const [offerPrice, setOfferPrice] = useState([]);
	const [materialRoadmap, setMaterialRoadmap] = useState([]);
	const [isShowFolderPopup, setIsShowFolderPopup] = useState(false);
	const [isShowCreateNewFolder, setIsShowCreateNewFolder] = useState(false);
	const [currentLikedStyle, setCurrentLikedStyle] = useState(null);
	const location = useLocation();
	const [publishStatus, setPublishStatus] = useState([]);

	useEffect(() => {
		// To re-focus <AsyncSearch /> component when it is Closed
		dispatch(setIsTechpackOpen(true));
	}, []);

	const sourcePage = {
		PRODUCT_LIST: 'PRODUCT_LIST', // list of product ids to view designs using left/right arrow
		ORDER_DETAILS: 'ORDER_DETAILS', // specific order id and that order designs
		COLLECTION_DETAILS: 'COLLECTION_DETAILS', // specific collection id and that collections designs
		OTHERS: 'OTHERS' // no left/right arrow
	};
	const dropdownRef = useRef();
	const dispatch = useDispatch();
	const closeButtonRef = useRef();

	const fetchProductQRCode = async () => {
		try {
			const { data } = await ApiClient.GET('getProductQrCode', id);
			setDesignQrCode(data);
		} catch (error) {
			if (error.response && error.response.data && error.response.data.message) {
				toastError(error.response.data.message);
			} else {
				toastError('Something went wrong');
			}
		}
	};

	const fetchDesignPublishStatus = async () => {
		try {
			const data = await getDesignPublishStatus(id);
			setPublishStatus(data);
		} catch (error) {
			printApiError(error);
		}
	};

	useEffect(() => {
		(async () => {
			try {
				const data = await fetchLatestMeasurementTypeInfo(id);
				fetchDesignPublishStatus();
				fetchProductQRCode();
				setPomAndSizeList(data);
				setInitialMeasurementTable(data?.tableData);
				setHasShowActualAndDiffColumn(data?.hasShowColumn);
				setSizeCategorySequence(data.sizeCategorySequenceMap);
				setMeasurementTable(processMeasurementData(data?.tableData));
				setFitWiseSizeList(processFitWiseSizeList(data?.tableData));
				setOtherMesasurementVersion(data?.otherAvailableMeasurementTypes);
			} catch {}
		})();
	}, []);

	useEffect(() => {
		if (productMaterialsList.length > 0) {
			let tempFabricList = [];
			let tempTrimsList = [];
			let tempBrandingList = [];
			productMaterialsList.map((obj, index) => {
				obj.productMaterialIndexNumber = index;
				if ([MATERIALS_TYPE.MAIN_FABRIC, MATERIALS_TYPE.EXTRA_FABRIC].includes(obj.materialType)) {
					tempFabricList.push(obj);
				} else if ([MATERIALS_TYPE.TRIMS].includes(obj.materialType)) {
					tempTrimsList.push(obj);
				} else if ([MATERIALS_TYPE.BRANDING].includes(obj.materialType)) {
					tempBrandingList.push(obj);
				}
			});
			let tempObj = {
				fabric: tempFabricList,
				trims: tempTrimsList,
				branding: tempBrandingList
			};
			setProductMaterialsTypeObj(tempObj);
		}
	}, [productMaterialsList]);

	useEffect(() => {
		if (designToolStore?.id) {
			fetchMaterialUnitType().then((res) => {
				setAllUnitTypes(res);
			});
			onSetActiveTab();
		}
	}, [designToolStore?.id]);

	useEffect(() => {
		if (productId) {
			dispatch(getMemberList(productId));
			dispatch(productWiseGroupDocument(productId));
			dispatch(fetchProductInfo(productId));
			dispatch(fetchProductMaterials(productId));
			fetchArtBoard(productId);
		}
	}, [productId]);

	useEffect(() => {
		setProductId(id);
	}, [id]);

	useEffect(() => {
		if (id && source && source === sourcePage.COLLECTION_DETAILS) {
			ApiClient.GET('fetchCollectionByProduct', id)
				.then((response) => {
					if (response.data?.productResponseList) {
						let idList = response.data?.productResponseList
							?.filter(
								(item) =>
									item.isBasicInfoUpdated && item.extraFlag && showDesignViewPage(item)
							)
							.map((item) => item.id);
						setAllProductIds(idList);
					}
				})
				.catch((error) => {
					toastError(error.response.data.message);
				});
		} else if (source && source === sourcePage.PRODUCT_LIST && designIdList) {
			setAllProductIds(designIdList);
		} else if (source && source === sourcePage.ORDER_DETAILS && orderId) {
			ApiClient.GET('getProjectProducts', orderId)
				.then(({ data }) => {
					if (data) {
						let ids = data.map((item) => item.id);
						setAllProductIds(ids);
					}
				})
				.catch(() => {});
		}
	}, [id, orderId, designIdList]);

	useEffect(() => {
		setSelectedInitialCostingId(initialCostingId);
	}, [initialCostingId]);

	useEffect(() => {
		if (isCostingRequestFromBuyer && costingItemList) {
			let uniqueInitialCostingIds = [
				...new Set(costingItemList?.map((item) => item?.initialCostingId))
			];
			setInitialCostingIds(uniqueInitialCostingIds);
		}
	}, [costingItemList]);

	const getBasePrice = async () => {
		await ApiClient.GET('fetchInitialCostingFromCosting', selectedInitialCostingId)
			.then((response) => {
				setBaseprice(response?.data?.totalCost?.toFixed(2) || null);
			})
			.catch((error) => {
				toastError(error.response.data.message);
			});
	};

	useEffect(() => {
		if (isCostingRequestFromBuyer && selectedInitialCostingId) {
			getBasePrice();
		}
	}, [selectedInitialCostingId]);

	const getOfferPriceForProduct = async () => {
		try {
			const response = await getPickAndChoosePrice(id);
			setOfferPrice(response[id]);
		} catch {}
	};

	useEffect(() => {
		getOfferPriceForProduct();
	}, [id]);

	const getOfferPrice = () => {
		let offerPriceValue;

		if (offerPrice?.length === 1) {
			offerPriceValue = `$${offerPrice[0].offerPrice.toFixed(2)}`;
		} else {
			const minPrice = Math.min(...offerPrice.map((item) => item.offerPrice));
			const maxPrice = Math.max(...offerPrice.map((item) => item.offerPrice));
			offerPriceValue = `$${minPrice.toFixed(2)}-$${maxPrice.toFixed(2)}`;
		}
		return offerPriceValue;
	};

	const getProductionCostExpDate = () => {
		if (offerPrice) {
			let priceUpdateDate = new Date(offerPrice[0]?.basePriceUpdatedAt);
			let expirationDate = new Date(priceUpdateDate);
			expirationDate.setDate(expirationDate.getDate() + 90);
			return changeDateFormat(expirationDate, '', 'Do MMM, YYYY');
		}
	};

	const loadPrevDesign = () => {
		setIsNextAndPrev(true);
		if (isCostingRequestFromBuyer) {
			let currentIndex = initialCostingIds.findIndex((item) => item == selectedInitialCostingId);
			if (currentIndex === -1) return;
			let newIndex = currentIndex - 1 < 0 ? initialCostingIds.length - 1 : currentIndex - 1;
			setSelectedInitialCostingId(initialCostingIds[newIndex]);
			const selectedProductId = costingItemList?.find(
				(item) => item?.initialCostingId === initialCostingIds[newIndex]
			)?.productId;
			dispatch(
				setCurrentActivePage({
					id: selectedProductId,
					type: 'PRODUCT_CONVERSATION',
					pageType: 'DETAILS'
				})
			);
			setProductId(selectedProductId);
		} else {
			let currentIndex = allProductIds.findIndex((item) => item == productId);
			if (currentIndex === -1) return;
			let newIndex = currentIndex - 1 < 0 ? allProductIds.length - 1 : currentIndex - 1;
			dispatch(
				setCurrentActivePage({
					id: allProductIds[newIndex],
					type: 'PRODUCT_CONVERSATION',
					pageType: 'DETAILS'
				})
			);
			setProductId(allProductIds[newIndex]);
		}
	};

	const loadNextDesign = () => {
		setIsNextAndPrev(true);
		if (isCostingRequestFromBuyer) {
			let currentIndex = initialCostingIds.findIndex((item) => item == selectedInitialCostingId);
			if (currentIndex === -1) return;
			let newIndex = currentIndex + 1 >= initialCostingIds.length ? 0 : currentIndex + 1;
			setSelectedInitialCostingId(initialCostingIds[newIndex]);
			const selectedProductId = costingItemList?.find(
				(item) => item?.initialCostingId === initialCostingIds[newIndex]
			).productId;
			dispatch(
				setCurrentActivePage({
					id: selectedProductId,
					type: 'PRODUCT_CONVERSATION',
					pageType: 'DETAILS'
				})
			);
			setProductId(selectedProductId);
		} else {
			let currentIndex = allProductIds.findIndex((item) => item == productId);
			if (currentIndex === -1) return;

			if (
				source === sourcePage.PRODUCT_LIST &&
				loadMoreDesign &&
				currentIndex + 3 >= allProductIds.length
			) {
				onLastDesignReached();
			}

			let newIndex = currentIndex + 1 >= allProductIds.length ? 0 : currentIndex + 1;
			dispatch(
				setCurrentActivePage({
					id: allProductIds[newIndex],
					type: 'PRODUCT_CONVERSATION',
					pageType: 'DETAILS'
				})
			);
			setProductId(allProductIds[newIndex]);
		}
	};

	const fetchArtBoard = async (productId) => {
		if (productId) {
			setIsLoading(true);
			await ApiClient.GET('fetchArtBoard', productId)
				.then((response) => {
					setArtBoards(response.data);
					setIsLoading(false);
				})
				.catch(() => {
					setIsLoading(false);
				});
		}
	};

	const isPresentationAvailable = () => {
		return (
			designToolCommentStore?.documentResponse?.front?.docUrl ||
			designToolCommentStore?.documentResponse?.back?.docUrl
		);
	};

	const downloadTechpack = async () => {
		let currentTime = moment(new Date()).format('DD MMM [AT] hh:mm A');
		setDownloadLoading(true);
		await ApiClient.POST('downloadTechPack', {}, productId + '?currentTime=' + currentTime)
			.then((response) => {
				if (response.data) {
					setDownloadLoading(false);
					window.open(response.data, '_parent');
				}
			})
			.catch((error) => {
				setDownloadLoading(false);
				toastError(error?.response?.data?.message || 'Something went wrong!');
			});
	};

	const onClickGoToAction = (routeName) => {
		window.open(`/designs/edit/${productId}?activeTab=${routeName}`, '_blank');
	};

	useEffect(() => {
		setIsLiked(designToolStore.liked ? true : false);
	}, [designToolStore]);

	const onLikeProduct = async (id) => {
		setCurrentLikedStyle(id);
		!isShowFolderPopup && setIsShowFolderPopup(true);
		setIsLiked(true);
		let response = await dispatch(likeProduct(id));
		if (response) {
			setIsLiked(true);
		}
	};

	const publishDesign = () => {
		const param = `publish?ids=${productId}`;
		ApiClient.POST('publishDesign', {}, param)
			.then(() => {
				dispatch(fetchProductInfo(productId));
				if (updateProductStatus) updateProductStatus();
				setIsShowLook(false);
				toastSuccess('Published successfully', 'bottom-right');
				setIsLoading(false);
			})
			.catch(({ response }) => {
				if (response && response.data.message) {
					toastError(response.data.message);
					setIsLoading(false);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const unPublishDesign = () => {
		ApiClient.POST('unPublishDesign', {}, productId + '/unpublish')
			.then(() => {
				dispatch(fetchProductInfo(productId));
				if (updateProductStatus) updateProductStatus();
				toastSuccess('Unpublished successfully', 'bottom-right');
			})
			.catch((error) => {
				toastError(error.message);
			});
	};

	const renderAddToCollection = () => {
		if (showAddCollectionPopup) {
			return (
				<AddDesignToCollection
					type="ADD_NEW"
					title="Copy or move to collection"
					onAddDesign={() => {
						setShowAddCollectionPopup(false);
					}}
					onCancel={() => {
						setShowAddCollectionPopup(false);
					}}
					designIdList={[productId]}
				/>
			);
		}
	};

	const renderFabricList = () => {
		if (designToolStore?.fabrics?.length > 1) {
			return designToolStore?.fabrics?.map((item, index) => {
				index++;
				if (index < 3) {
					return (
						<React.Fragment key={`fabric_${index}`}>
							<p key={`fabric_${index}`} className="regular-14 gray_dark_01">
								{`Fabric ${index}`}: {item.fabricDetailsForPresentation}
							</p>
							<p key={`gsm_${index}`} className="regular-14 gray_dark_01">
								Weight: {item.weight}
							</p>
							<br />
						</React.Fragment>
					);
				}
			});
		} else if (designToolStore?.fabrics) {
			return (
				<>
					<p className="regular-14 gray_dark_01">
						Fabric: {designToolStore?.fabrics[0]?.fabricDetailsForPresentation}
					</p>
					<p className="regular-14 gray_dark_01">Weight: {designToolStore?.fabrics[0]?.weight}</p>
				</>
			);
		}
	};

	const onCloseALl = () => {
		dispatch(clearDesignTool());
		setEditModal(false);
		setOpenCostingPanel(false);
		dispatch(clearCurrentActivePage());
		setOpenCommentPanel(false);
		setActiveId(null);
		setIsShowNitexTechpack(false);
		onCloseViewModal();
		dispatch(removeSearchResult(''));
		dispatch(setIsTechpackOpen(false));
	};

	const renderCloseButton = () => {
		return (
			<button type="button" className="close" onClick={() => onCloseALl()} ref={closeButtonRef}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="25"
					viewBox="0 0 24 25"
					fill="none"
				>
					<path
						d="M18 6.21423L6 18.6428"
						stroke="white"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M6 6.21423L18 18.6428"
						stroke="white"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</button>
		);
	};

	const renderTopBar = () => {
		return (
			<div className="modal-header">
				<nav className="navbar navbar-expand-lg navbar-light design-tool-header">
					<>
						<div className="toggle-menu-btn">
							<a
								className="back-btn"
								onClick={() => {
									dispatch(clearCurrentActivePage());
									setOpenCommentPanel(false);
									onCloseViewModal();
								}}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/Left-arrow.svg`} alt="back" />
							</a>
							<Link
								to={`/set/view/${designToolStore?.setProductInfo?.id}`}
								onClick={() => {
									dispatch(clearCurrentActivePage());
									setOpenCommentPanel(false);
									onCloseViewModal();
								}}
							>
								{designToolStore?.setProductInfo?.name}&nbsp;
								{designToolStore?.setProductInfo?.isSet && (
									<span className="status set">Set</span>
								)}
							</Link>
						</div>
						<div
							className="design-selection-dropdown one-third-item"
							onClick={() => setEditModal(!editModal)}
						>
							<div className="d-flex justify-content-center align-items-center">
								<span className="cursor-pointer">
									<img
										src={`${process.env.PUBLIC_URL}/icons/narrow-view-dark.svg`}
										alt="more"
										className="more-icon"
									/>
								</span>
								<div
									className="dropdown-btn d-flex align-items-center cursor-pointer"
									onClick={() => setIsShowUpdateBasicInfo(true)}
								>
									<span className="regular-14 gray_dark_01">
										/{designToolStore?.referenceNumber}
									</span>
								</div>
							</div>
						</div>
						<div className="profile-and-comments one-third-item">
							<ul className="d-flex menus">
								<li className="initial-costing">
									<span onClick={() => setOpenCostingPanel((prev) => !prev)}></span>

									<div className="d-flex production-and-offer-prices">
										<div
											className="production-price"
											onClick={() => {
												setOpenCostingPanel((prev) => !prev);
												fetchDesignPublishStatus();
											}}
										>
											<p className="regular-10 gray_dark_01 text-nowrap">
												Production Cost
											</p>
											<p className="d-flex align-items-center mt-half">
												{!openCostingPanel ? (
													<img
														src={`${process.env.PUBLIC_URL}/icons/left-arrwo-dark.svg`}
														alt="message"
													/>
												) : (
													<img
														className="pr-1"
														src={`${process.env.PUBLIC_URL}/icons/chip-close.svg`}
														alt="message"
													/>
												)}
												{isCostingRequestFromBuyer ? (
													basePrice ? (
														<Tooltip
															title={`Exp. Date: ${getProductionCostExpDate()}`}
															placement="top"
															arrow
														>
															<span className="semibold-14">${basePrice}</span>
														</Tooltip>
													) : (
														'COSTING'
													)
												) : designToolStore?.basePrice && isShowPriceOnDesign() ? (
													<Tooltip
														title={`Exp. Date: ${getProductionCostExpDate()}`}
														placement="top"
														arrow
													>
														<span className="semibold-14">
															${Number(designToolStore?.basePrice).toFixed(2)}
														</span>
													</Tooltip>
												) : (
													'COSTING'
												)}
											</p>
										</div>

										{offerPrice && (
											<div className="offer-price">
												<p className="regular-10 gray_dark_01 text-nowrap">
													Offer Price
												</p>
												<p className="semibold-14 text-nowrap"> {getOfferPrice()}</p>
												<OfferPriceDropdown offerPriceInfo={offerPrice} />
											</div>
										)}
									</div>
								</li>
								<li>
									{isLiked ? (
										<img
											src={`${process.env.PUBLIC_URL}/icons/favorite.svg`}
											alt="favourite"
											className="add-to-favorite"
										/>
									) : (
										<img
											src={`${process.env.PUBLIC_URL}/icons/not-favorite.svg`}
											alt="not-favourite"
											className="add-to-favorite"
											onClick={() => {
												onLikeProduct(id);
											}}
										/>
									)}
								</li>
								<li
									onClick={() => {
										dispatch(clearCurrentActivePage());
										setOpenCommentPanel(false);
										downloadTechpack();
									}}
								>
									<img
										src={`${process.env.PUBLIC_URL}/icons/download-gray-dark-02.svg`}
										alt="download"
									/>
								</li>
								<li
									onClick={() => {
										dispatch(
											setCurrentActivePage({
												id: productId,
												type: 'PRODUCT_CONVERSATION',
												pageType: 'DETAILS'
											})
										);
										setOpenCommentPanel(!openCommentPanel);
									}}
								>
									<img
										src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`}
										alt="comments"
										className="comments"
									/>
								</li>
								<li
									onClick={() => {
										localStorage.setItem('fromRoute', location.pathname);
										dispatch(clearCurrentActivePage());
										setOpenCommentPanel(false);
										// onCloseViewModal();
										window.open(`/designs/edit/${productId}`, '_blank');
									}}
								>
									<img src={`${process.env.PUBLIC_URL}/icons/edit-tool.svg`} alt="edit" />
								</li>
								<li className="more-options" ref={dropdownRef}>
									<img
										src={`${process.env.PUBLIC_URL}/icons/more_vertical.svg`}
										alt="more"
										className="more"
										onClick={() => {
											setIsShowDropdown((prev) => !prev);
											if (isShowLook) setIsShowLook(false);
										}}
									/>
									{isShowDropdown && (
										<>
											<ul className="dropdown-menu dropdown-menu-right shadow-lg show">
												<li onClick={() => setShowAddCollectionPopup(true)}>
													<span>Add to collection</span>
												</li>
												<li
													onClick={() => {
														navigator.clipboard.writeText(
															`${BASE_FRONT_END_URL}/collections/list?openDesign=true&productId=${id}`
														);
														toastSuccess('Copied');
													}}
												>
													<span>Copy design link</span>
												</li>
												<li
													onClick={() => {
														navigator.clipboard.writeText(
															designToolStore?.referenceNumber
														);
														toastSuccess('Copied');
													}}
												>
													<span>Copy design number</span>
												</li>
												{getPublishStatus(publishStatus)?.map((item) => (
													<li className="default-text">
														<div className="d-flex align-items-center">
															<span className="regular-12">
																{item?.successIcon ? (
																	<SuccessIcon />
																) : (
																	<CloseCircleIcon />
																)}{' '}
																{item?.name}
															</span>
														</div>
													</li>
												))}

												<li className="my-2 mx-3">
													<button
														onClick={() => {
															if (
																isAllCriteriaCompleted(publishStatus) &&
																designToolStore?.availabilityStatus ===
																	'PUBLISHED'
															) {
																unPublishDesign();
															} else {
																publishDesign();
															}
														}}
														className="button size32 w-100"
														disabled={!isAllCriteriaCompleted(publishStatus)}
													>
														{isAllCriteriaCompleted(publishStatus) &&
														designToolStore?.availabilityStatus === 'PUBLISHED'
															? 'Unpublish'
															: 'Publish'}
													</button>
												</li>
											</ul>
										</>
									)}
									{renderAddToCollection()}
								</li>
							</ul>
							{isShowFolderPopup && (
								<div>
									<SelectFolderPopup
										onClose={() => setIsShowFolderPopup(false)}
										isShowCreateNew={isShowCreateNewFolder}
										setIsShowCreateNew={setIsShowCreateNewFolder}
										currentLikedStyle={currentLikedStyle}
									/>
								</div>
							)}
						</div>
					</>
				</nav>

				{renderCloseButton()}
			</div>
		);
	};

	const renderMeasurementTables = () => {
		const renderTables = () => {
			if (
				['NITEX_DEVELOPMENT', 'BUYER_FIT_DEVELOPMENT'].includes(
					pomAndSizeList?.measurementType?.constant
				)
			) {
				let clone1 = JSON.parse(JSON.stringify(measurementTable));
				let clone2 = JSON.parse(JSON.stringify(measurementTable));
				let firstAndSecondFitTableData = clone1.map((item) => {
					let modifiedFitInfo = {};
					if (item.fitInfo?.FIRST_FIT) {
						modifiedFitInfo['FIRST_FIT'] = item.fitInfo.FIRST_FIT;
					}
					if (item.fitInfo?.SECOND_FIT) {
						modifiedFitInfo['SECOND_FIT'] = item.fitInfo.SECOND_FIT;
					}
					item.fitInfo = modifiedFitInfo;
					return item;
				});

				let secondAndThirdFitTableData = clone2.map((item) => {
					let modifiedFitInfo = {};
					if (item.fitInfo?.SECOND_FIT) {
						modifiedFitInfo['SECOND_FIT'] = item.fitInfo.SECOND_FIT;
					}
					if (item.fitInfo?.THIRD_FIT) {
						modifiedFitInfo['THIRD_FIT'] = item.fitInfo.THIRD_FIT;
					}
					item.fitInfo = modifiedFitInfo;
					return item;
				});
				let firstAndSecondFitInitialData = initialMeasurementTableData.slice(0, 2);
				let secondAndThirdFitInitialData = initialMeasurementTableData.slice(1);
				let firstTblSizeList = {};
				let secondTblSizeList = {};
				if (fitWiseSizeList?.FIRST_FIT) {
					firstTblSizeList['FIRST_FIT'] = fitWiseSizeList['FIRST_FIT'];
				}
				if (fitWiseSizeList?.SECOND_FIT) {
					firstTblSizeList['SECOND_FIT'] = fitWiseSizeList['SECOND_FIT'];
					secondTblSizeList['SECOND_FIT'] = fitWiseSizeList['SECOND_FIT'];
				}
				if (fitWiseSizeList?.THIRD_FIT) {
					secondTblSizeList['THIRD_FIT'] = fitWiseSizeList['THIRD_FIT'];
				}
				return (
					<>
						{Object.keys(firstTblSizeList).length > 0 && (
							<BuyerAndNitexMeasurementTable
								isMeasurementEditable={false}
								fitWiseSizeList={firstTblSizeList}
								tableData={firstAndSecondFitTableData}
								hasShowActualAndDiffColumn={hasShowActualAndDiffColumn}
								initialMeasurementTableData={firstAndSecondFitInitialData}
								pomAndSize={pomAndSizeList}
							/>
						)}
						{Object.keys(secondTblSizeList).length > 1 && (
							<BuyerAndNitexMeasurementTable
								isMeasurementEditable={false}
								fitWiseSizeList={secondTblSizeList}
								tableData={secondAndThirdFitTableData}
								hasShowActualAndDiffColumn={hasShowActualAndDiffColumn}
								initialMeasurementTableData={secondAndThirdFitInitialData}
								pomAndSize={pomAndSizeList}
							/>
						)}
					</>
				);
			} else if (['COSTING_GRADING', 'PP_SAMPLE'].includes(pomAndSizeList?.measurementType?.constant)) {
				return (
					<CostingAndPPSampleTable
						isMeasurementEditable={false}
						tableData={measurementTable}
						fitWiseSizeList={fitWiseSizeList}
						sizeCategorySequence={sizeCategorySequence}
						hasShowActualAndDiffColumn={hasShowActualAndDiffColumn}
						selectedMeasurementType={pomAndSizeList?.measurementType}
						parentComponent="TECH_PACK"
						pomAndSizeList={pomAndSizeList}
					/>
				);
			} else {
				return <></>;
			}
		};
		return (
			measurementTable &&
			measurementTable.length > 0 && (
				<div className="single-design-view-page">
					<div className="single-artboard-title d-flex justify-content-between">
						<p className="regular-16 weight-500 gray_dark_01 m-0 d-flex align-items-center">
							<span className="mr-1">MEASUREMENT CHART:</span>
							<img
								src={`${process.env.PUBLIC_URL}/icons/edit-tool.svg`}
								alt="edit"
								className="size-20 cursor-pointer"
								onClick={() => onClickGoToAction('measurement')}
							/>
							<span className="square-box ml-2 mr-1"></span>
							<span className="regular-14">{pomAndSizeList?.measurementType?.name}</span>
						</p>
						<p className="regular-14 weight-500">
							{otherMeasurementVersion &&
								otherMeasurementVersion.length > 0 &&
								otherMeasurementVersion.map((version, index) => (
									<span className="mr-1 gray_dark_01" key={`${version}_${index}`}>
										{version.name && version.name.toUpperCase()}
										{insertSeparatorIfNeeded(otherMeasurementVersion, index, ',')}
									</span>
								))}
							<span className="gray_dark_02">: OTHERS VERSION</span>
						</p>
					</div>
					<div className="full-body">{renderTables()}</div>
				</div>
			)
		);
	};

	const updateDesignSelection = (product) => {
		dispatch(
			updateDesignViewModalInfo({
				mergeProductList: product.isSet ? product.setMemberProductIds : [],
				isShowMergeTechPack: product.isSet,
				id: product.id
			})
		);
	};

	const renderTechpack = () => (
		<div className="modal-content">
			<div className="modal-body">
				{openCommentPanel && (
					<DesignToolRightSideBar
						productId={productId}
						brandName={designToolStore?.brandName}
						toolType={'design-tool'}
						selectedPostId={selectedCommentId}
					/>
				)}
				{openCostingPanel && (
					<CostingForm
						costingId={isCostingRequestFromBuyer ? selectedInitialCostingId : productId}
						mention={false}
						onUpdateCostingStatus={() => {
							if (onUpdateCostingStatus) {
								onUpdateCostingStatus(productId);
							}
							if (isCostingRequestFromBuyer) {
								getBasePrice();
							}
						}}
						productId={productId}
						isCostingRequestFromBuyer={!!isCostingRequestFromBuyer}
						getBasePrice={getBasePrice}
					/>
				)}
				{editModal && (
					<DesignSelectionModal
						closeModal={setEditModal}
						setProduct={updateDesignSelection}
						productId={productId}
						requestFrom="TECHPACK_VIEW"
					/>
				)}
				{downloadLoading && <TimeBasedLoader startLoader={downloadLoading} />}

				{isShowNitexTechpack ? (
					<>
						{source && source !== sourcePage.OTHERS && (
							<div className="design-slide-buttons">
								<button className="prev" onClick={() => loadPrevDesign()}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
									>
										<path
											d="M15 6L9 12L15 18"
											stroke="white"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</button>
								<button className="next" onClick={() => loadNextDesign()}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
									>
										<path
											d="M9 18L15 12L9 6"
											stroke="white"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</button>
							</div>
						)}

						{isPresentationAvailable() && (
							<div className="single-design-view-page">
								<div className="presentation-view-container">
									<div className="images-view-section">
										<div className="one-third full-photo">
											{designToolCommentStore?.documentResponse?.front?.docUrl && (
												<img
													src={
														designToolCommentStore?.documentResponse?.front
															?.docUrl
													}
													alt="front"
												/>
											)}
										</div>
										<div className="one-third full-photo">
											{designToolCommentStore?.documentResponse?.back?.docUrl && (
												<img
													src={
														designToolCommentStore?.documentResponse?.back?.docUrl
													}
													alt="front"
												/>
											)}
										</div>
										<div className="one-third fabric-photo">
											<div className="single-fabric">
												{designToolCommentStore?.documentResponse?.fabric?.docUrl && (
													<img
														src={
															designToolCommentStore?.documentResponse?.fabric
																?.docUrl
														}
														alt="front"
													/>
												)}
											</div>
											<div className="single-fabric">
												{designToolCommentStore?.documentResponse?.embellishment
													?.docUrl && (
													<img
														src={
															designToolCommentStore?.documentResponse
																?.embellishment?.docUrl
														}
														alt="front"
													/>
												)}
											</div>
											<p className="regular-14 gray_dark_01">
												Item: {designToolStore?.name}
											</p>
											{renderFabricList()}
											<img
												src={`${process.env.PUBLIC_URL}/icons/edit-tool.svg`}
												alt="edit"
												className="size-20 cursor-pointer"
												onClick={() => onClickGoToAction('presentation')}
											/>
										</div>
									</div>
								</div>
							</div>
						)}

						{designToolCommentStore?.documentResponse?.embellishment?.docUrl && (
							<div className="single-design-view-page">
								<div className="single-artboard-title">
									<p className="regular-16 weight-500 gray_dark_01 m-0">Key details</p>
								</div>
								<div className="full-artboard">
									<img
										src={designToolCommentStore?.documentResponse?.embellishment?.docUrl}
										alt=""
									/>
								</div>
							</div>
						)}

						{artBoards.map((artBoard, index) => {
							return (
								<div className="single-design-view-page" key={artBoard?.id}>
									<div className="single-artboard-title w-100 d-flex justify-content-between item-center">
										<p className="regular-16 weight-500 gray_dark_01 m-0">
											{artBoard.name}
										</p>
										{designQrCode && index === 0 && (
											<img src={designQrCode} alt="QR-code" className="qr-code" />
										)}
									</div>
									<div className="full-artboard">
										<img src={artBoard.docUrl} alt="" />
									</div>
								</div>
							);
						})}

						{productMaterialsList.length > 0 && (
							<div className="single-design-view-page">
								<div className="single-artboard-title">
									<p className="regular-16 weight-500 gray_dark_01 m-0">
										<span className="mr-1">MATERIAL LIST</span>
										<img
											src={`${process.env.PUBLIC_URL}/icons/edit-tool.svg`}
											alt="edit"
											className="size-20 cursor-pointer"
											onClick={() => onClickGoToAction('materials')}
										/>
									</p>
								</div>
								<div className="full-body">
									{Object.keys(productMaterialsTypeObj).length === 3 &&
										productMaterialsTableRender(
											productMaterialsTypeObj?.fabric,
											MATERIAL_TITLE_NAME.FABRIC
										)}
									{Object.keys(productMaterialsTypeObj).length === 3 &&
										productMaterialsTableRender(
											productMaterialsTypeObj?.trims,
											MATERIAL_TITLE_NAME.TRIMS
										)}
									{Object.keys(productMaterialsTypeObj).length === 3 &&
										productMaterialsTableRender(
											productMaterialsTypeObj?.branding,
											MATERIAL_TITLE_NAME.BRANDING
										)}
								</div>
							</div>
						)}

						{designToolCommentStore?.howToMeasureDocument?.docUrl && (
							<div className="single-design-view-page">
								<div className="single-artboard-title">
									<p className="regular-16 weight-500 gray_dark_01 m-0">HOW TO MEASURE</p>
								</div>
								<div className="full-artboard">
									<img src={designToolCommentStore?.howToMeasureDocument?.docUrl} alt="" />
								</div>
							</div>
						)}
						{renderMeasurementTables()}
					</>
				) : activeId ? (
					renderDocuments()
				) : (
					''
				)}
			</div>
		</div>
	);

	const renderDocuments = () => {
		const fileType = getFileType(selectedDocUrl);
		if (fileType === 'PDF') {
			return (
				<div className="embed-responsive embed-responsive-16by9">
					<iframe className="embed-responsive-item" src={selectedDocUrl} allowFullScreen />
				</div>
			);
		} else
			return (
				<div className="no-preview-file">
					<div>
						<p className="semibold-14 gray_dark_02">No preview available </p>
						<button
							className="button outline size32 mt-3"
							onClick={() => window.open(selectedDocUrl, '_blank')}
						>
							<img
								src={`${process.env.PUBLIC_URL}/icons/download-dark-20.svg`}
								alt="download"
								className="mr-1"
							/>
							Download file
						</button>
					</div>
				</div>
			);
	};

	const onSetActiveTab = () => {
		if (designToolStore?.extraFlag?.isArtBoardCreated || designToolStore?.photographyUpdated) {
			setIsShowNitexTechpack(true);
		} else if (designToolStore?.allNotImageDocuments?.length > 0) {
			setActiveId(designToolStore?.allNotImageDocuments[0]?.id);
			setSelectedDocUrl(designToolStore?.allNotImageDocuments[0]?.docUrl);
		}
		if (
			isShowUpdateBasicInfo === null &&
			Object.prototype.hasOwnProperty.call(designToolStore, 'isBasicInfoUpdated')
		) {
			setIsShowUpdateBasicInfo(!designToolStore?.isBasicInfoUpdated);
		}
	};

	const getUnitTypes = (unit) => {
		return allUnitTypes?.map((item) => {
			if (unit === item.value) return item.label;
		});
	};
	const conditionWiseBookedColumnAdd = (item) => {
		if (item?.bookedQuantity !== undefined && item?.issueInventoryStatus === STATUS.BOOKED) {
			return (
				<td>
					<p>
						{item?.bookedQuantity}&nbsp;
						{isFabric(item?.materialType)
							? getConsumptionUnit(item)
							: getConsumptionUnitForTrimsAccessories(item)}
					</p>
				</td>
			);
		} else if (item?.bookedQuantity !== undefined && item?.issueInventoryStatus !== STATUS.BOOKED) {
			return (
				<td>
					<>
						{item?.issueInventoryStatus === STATUS.CANCELLED && (
							<p className="regular-14 mb-2 red"> Booking cancel</p>
						)}
						{item?.issueInventoryStatus === STATUS.ACTIVE && (
							<p className="regular-14 mb-2 green">
								Issued: {item?.issuedQuantity} &nbsp;
								{isFabric(item?.materialType)
									? getConsumptionUnit(item)
									: getConsumptionUnitForTrimsAccessories(item)}
							</p>
						)}
						<p
							className={
								'regular-14 gray_dark_01 ' +
								(item?.issueInventoryStatus === STATUS.CANCELLED ? 'red' : '')
							}
						>
							{item?.bookedQuantity}&nbsp;
							{isFabric(item?.materialType)
								? getConsumptionUnit(item)
								: getConsumptionUnitForTrimsAccessories(item)}
						</p>
					</>
				</td>
			);
		} else {
			return <td />;
		}
	};

	const materialDetailsRender = (title, objectInfo) => {
		if (title === MATERIAL_TITLE_NAME.FABRIC) {
			return (
				<>
					<p className="regular-12 gray_dark_03">{objectInfo?.fabricType}</p>
					<p className="regular-14 gray_dark_01 mb-2">{objectInfo?.construction}</p>
					{objectInfo?.compositionPartList?.map((compositionPart, index) => {
						return (
							<p className="regular-14 gray_dark_01 text-nowrap" key={`composition_${index}`}>
								{compositionPart?.percentage} {'% '}
								{compositionPart?.fiberName?.toProperCase()}
							</p>
						);
					})}
					<p className="regular-14 gray_dark_01 mt-2">
						{objectInfo?.gsm && objectInfo.gsm}{' '}
						{objectInfo?.gsm && objectInfo.weightUnit && objectInfo.weightUnit}
						{objectInfo?.weightType && ` (${objectInfo.weightType})`}
					</p>
				</>
			);
		} else if ([MATERIAL_TITLE_NAME.TRIMS, MATERIAL_TITLE_NAME.BRANDING].includes(title)) {
			return (
				<>
					<p className="weight-500 mb-2 gray_dark_01">
						{objectInfo?.subCategoryType ? objectInfo?.subCategoryType?.name : ''}
					</p>
					<p className="regular-14 gray_dark_01 mt-2">
						{categoryTypeSustainabilityForTrimsAndBranding(objectInfo)}
					</p>
					{someDetailsForTrimsAndBrandingRender(objectInfo)}
				</>
			);
		}
	};

	const onClickRoadmap = async (fabricId) => {
		setSelectedMaterialRoadmap(fabricId);
		try {
			dispatch(openLoader());
			const roadmapData = await getPairFabricById(fabricId);
			if (roadmapData.supplierList) {
				setMaterialRoadmap(roadmapData?.supplierList);
			} else {
				toastInfo('No Roadmap Data available');
			}
		} finally {
			dispatch(closeLoader());
		}
	};

	const productMaterialItemRender = (item, titleName) => {
		let objectInfo = null;
		if (MATERIAL_TITLE_NAME.FABRIC === titleName) objectInfo = item.fabricDetailsTableResponse;
		else if ([MATERIAL_TITLE_NAME.TRIMS, MATERIAL_TITLE_NAME.BRANDING].includes(titleName))
			objectInfo = item.trimsAndBrandingTableResponse;
		return (
			<tr key={item.id}>
				<td>
					<img
						src={addImageSuffix(item.documentPath, '_xicon')}
						alt=""
						className="cell-img pr-2"
						onError={(e) => {
							e.target.onerror = null;
							e.target.src = `${process.env.PUBLIC_URL}/images/fabric-default.png`;
						}}
					/>
				</td>
				<td className="placement-column">
					{[MATERIAL_TITLE_NAME.TRIMS, MATERIAL_TITLE_NAME.BRANDING].includes(titleName) && (
						<p className="regular-14 gray_dark_01 mb-2">
							{objectInfo?.subCategoryType?.category}
						</p>
					)}

					<div className="d-flex flex-wrap gap-2">
						{item?.placementResponseList?.length > 0
							? item?.placementResponseList?.map((placement) => (
									<span key={placement?.id} className="chip gray-chip">
										{placement?.name}
									</span>
								))
							: ''}
					</div>
				</td>
				<td className="placement-column">
					<span className="regular-14 gray_dark_01">
						<p
							className="text-underline cursor-pointer"
							onClick={() =>
								window.open(
									`/materials/view/${item?.libraryId}?type=${titleName.toUpperCase()}`,
									'_blank'
								)
							}
						>
							{item?.referenceNumber}
						</p>

						<p className="mt-4">
							{capitalizeFirstLetter(item?.fabricDetailsTableResponse?.pairType)}
						</p>
						<p>{item?.fabricDetailsTableResponse?.pairMaterialReferenceNumber}</p>
						{item?.isImported && <ImportedTag />}
					</span>
					<p
						className="regular-12 gray_dark_01 text-underline mt-12 cursor-pointer"
						onClick={() => onClickRoadmap(item?.libraryId)}
					>
						Roadmap
					</p>
					{selectedMaterialRoadmap === item?.libraryId && materialRoadmap?.length > 0 && (
						<MaterialRoadmapView
							onClose={() => {
								setSelectedMaterialRoadmap(null);
								setMaterialRoadmap([]);
							}}
							showCloseButton
							supplierList={materialRoadmap}
						/>
					)}
				</td>
				<td>{materialDetailsRender(titleName, objectInfo)}</td>
				<td>
					<div className="color-column">
						<div className="color-list">
							<AddedColors
								colorGroupResponseList={
									item?.materialColorResponse?.colorGroupResponseList?.length > 0
										? item?.materialColorResponse?.colorGroupResponseList
										: item?.baseMaterialColorResponse?.colorGroupResponseList
								}
								colorResponse={
									Object.keys(item.materialColorResponse.colorResponse).length > 0
										? item?.materialColorResponse?.colorResponse
										: item?.baseMaterialColorResponse?.colorResponse
								}
								colorType={
									item?.materialColorResponse?.colorType?.name
										? item?.materialColorResponse?.colorType?.name
										: item?.baseMaterialColorResponse?.colorType?.name
								}
								showPopup={false}
							/>
						</div>
					</div>
				</td>
				{MATERIAL_TITLE_NAME.TRIMS !== titleName && (
					<td>
						{(item?.fabricDetailsTableResponse?.shrinkageLength ||
							item?.fabricDetailsTableResponse?.shrinkageWidth) && <p>Shrinkage:</p>}
						<p className="mb-1">
							{item?.fabricDetailsTableResponse?.shrinkageLength && (
								<span>
									L={item?.fabricDetailsTableResponse?.shrinkageLength}%
									{item?.fabricDetailsTableResponse?.shrinkageWidth &&
										item?.fabricDetailsTableResponse?.shrinkageLength &&
										','}{' '}
								</span>
							)}
							{item?.fabricDetailsTableResponse?.shrinkageWidth && (
								<span>
									W=
									{item?.fabricDetailsTableResponse?.shrinkageWidth}%
								</span>
							)}
						</p>
						{item?.fabricDetailsTableResponse?.solidDyedGsm && (
							<p>S/D: {item?.fabricDetailsTableResponse?.solidDyedGsm} GSM </p>
						)}
						{item?.fabricDetailsTableResponse?.afterWashGsm && (
							<p className="mt-1">A/W: {item?.fabricDetailsTableResponse?.afterWashGsm} GSM</p>
						)}
					</td>
				)}

				{conditionWiseBookedColumnAdd(item, item.productMaterialIndexNumber)}
				<td className="consumption-column">
					<span className="regular-14 gray_dark_01">
						{item.quantity}&nbsp;
						{getUnitTypes(item.quantityUnit)}
					</span>
				</td>
				<td>
					<span className="regular-14 gray_dark_01">
						<p>{item?.supplierRefNumber}</p>
						<p className="regular-12 gray_dark_02 mt-1">{item?.supplierName}</p>
					</span>
				</td>
				<td>
					<span className="regular-14 gray_dark_01">{item.description}</span>
				</td>
			</tr>
		);
	};
	const productMaterialsTableRender = (list, titleName) => {
		if (list !== undefined && list.length > 0) {
			return (
				<>
					<p className="semibold-12 gray_dark_02 mt-3 mb-2">{titleName}</p>
					<div className="material-list-table">
						<div className="update-material-list-table table-responsive">
							<table className="table">
								<thead>
									<tr>
										<th>Image</th>
										<th>
											{[
												MATERIAL_TITLE_NAME.TRIMS,
												MATERIAL_TITLE_NAME.BRANDING
											].includes(titleName)
												? 'Material type & '
												: ''}
											Placement
										</th>
										<th>Reference</th>
										<th>Material details</th>
										<th>Color</th>
										{MATERIAL_TITLE_NAME.TRIMS !== titleName && <th>Shrinkage & GSM</th>}
										<th>Nitex inventory book Qty</th>
										<th className="consumption">Sample consumption</th>
										<th>Supplier</th>
										<th>Remarks</th>
									</tr>
								</thead>
								<tbody>
									{list?.map((item) => productMaterialItemRender(item, titleName))}
								</tbody>
							</table>
						</div>
					</div>
				</>
			);
		} else return '';
	};

	return ((!isLoading && !isNextAndPrev) || isNextAndPrev) && designToolStore?.id ? (
		<ModalContainer onCloseModal={onCloseALl} className="design-view-modal">
			<div className="update-teckpack-basic-info">{renderTopBar && renderTopBar()}</div>
			<div className="sample-style-detail">
				<DesignUpdate
					productId={productId}
					onSetNitexTab={() => {
						setIsShowNitexTechpack(true);

						setActiveId(null);
					}}
					activeId={activeId}
					isNitexTechpack={isShowNitexTechpack}
					onChangeActiveTab={(value) => {
						setIsShowNitexTechpack(false);

						setSelectedDocUrl(value.docUrl);

						setActiveId(value.id);
					}}
					onCloseALl={onCloseALl}
					fetchDesignPublishStatus={fetchDesignPublishStatus}
				/>
			</div>

			{renderTechpack()}
		</ModalContainer>
	) : (
		<LoaderComponent loading={isLoading} />
	);
};

export default DesignView;
